/* ZINKE — Länder- und Sprachauswahl mit Flaggen, 17.09.2026
   Macht aus Knopf + Liste in snippets/localization.liquid eine bedienbare
   Auswahl. Das echte <select> bleibt im Formular und trägt den Wert; die
   Liste setzt ihn nur und schickt das Formular ab. Ohne dieses Skript bleibt
   das normale Auswahlfeld sichtbar.

   Bedienung: Klick oder Pfeiltaste öffnet, Pfeile wandern, Enter/Leertaste
   wählt, Escape schließt. Klick daneben schließt ebenfalls. Liegt unter dem
   Knopf zu wenig Platz (Fußbereich am Seitenende), öffnet die Liste nach oben. */
(() => {
  'use strict';

  function einrichten(form) {
    if (!form || form.dataset.auswahlBereit === 'ja') return;
    const select = form.querySelector('[data-auswahl-select]');
    const knopf = form.querySelector('[data-auswahl-knopf]');
    const liste = form.querySelector('[data-auswahl-liste]');
    if (!select || !knopf || !liste) return;

    const optionen = Array.from(liste.querySelectorAll('[role="option"]'));
    if (!optionen.length) return;

    form.dataset.auswahlBereit = 'ja';
    form.classList.add('auswahl-bereit');

    const aktuelle = () => optionen.find(o => o.getAttribute('aria-selected') === 'true') || optionen[0];

    function oeffnen() {
      const platzUnten = window.innerHeight - knopf.getBoundingClientRect().bottom;
      liste.hidden = false;
      form.classList.toggle('auswahl-oben', platzUnten < Math.min(liste.scrollHeight + 16, 360));
      knopf.setAttribute('aria-expanded', 'true');
      const ziel = aktuelle();
      ziel.focus({ preventScroll: true });
      ziel.scrollIntoView({ block: 'nearest' });
    }

    function schliessen(fokusZurueck) {
      if (liste.hidden) return;
      liste.hidden = true;
      knopf.setAttribute('aria-expanded', 'false');
      if (fokusZurueck) knopf.focus();
    }

    function waehlen(option) {
      if (!option) return;
      if (option.dataset.wert === select.value) { schliessen(true); return; }
      select.value = option.dataset.wert;
      optionen.forEach(o => o.setAttribute('aria-selected', String(o === option)));
      const nameAlt = knopf.querySelector('.auswahl-name');
      const nameNeu = option.querySelector('.auswahl-name');
      if (nameAlt && nameNeu) nameAlt.textContent = nameNeu.textContent;
      schliessen(false);
      knopf.setAttribute('aria-busy', 'true');
      form.submit();
    }

    knopf.addEventListener('click', () => (liste.hidden ? oeffnen() : schliessen(true)));

    knopf.addEventListener('keydown', event => {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        oeffnen();
      }
    });

    liste.addEventListener('click', event => waehlen(event.target.closest('[role="option"]')));

    liste.addEventListener('keydown', event => {
      const i = optionen.indexOf(document.activeElement);
      switch (event.key) {
        case 'ArrowDown': event.preventDefault(); optionen[Math.min(i + 1, optionen.length - 1)].focus(); break;
        case 'ArrowUp':   event.preventDefault(); optionen[Math.max(i - 1, 0)].focus(); break;
        case 'Home':      event.preventDefault(); optionen[0].focus(); break;
        case 'End':       event.preventDefault(); optionen[optionen.length - 1].focus(); break;
        case 'Enter':
        case ' ':         event.preventDefault(); waehlen(optionen[i]); break;
        case 'Escape':    event.preventDefault(); schliessen(true); break;
        case 'Tab':       schliessen(false); break;
        default: {
          // Anfangsbuchstabe springt zum ersten passenden Land
          if (event.key.length === 1) {
            const b = event.key.toLowerCase();
            const treffer = optionen.find(o => (o.textContent || '').trim().toLowerCase().startsWith(b));
            if (treffer) treffer.focus();
          }
        }
      }
    });

    document.addEventListener('click', event => {
      if (!form.contains(event.target)) schliessen(false);
    });
  }

  function starten(bereich) {
    (bereich || document).querySelectorAll('form.auswahl').forEach(einrichten);
  }

  document.addEventListener('shopify:section:load', event => starten(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => starten());
  } else {
    starten();
  }
})();
